<template>
    <div class="flex flex-col gap-2 border-t-1 border-dark-blue w-full">
        <div v-for="service in service_tracker" class="border-b-1 border-dark-blue py-4 w-full" @click="service.open = !service.open">
            <div class="flex flex-row w-full place-content-between transition-all items-center" >
                <div class="view-h4 uppercase">{{service.data.title[mainStore.active_locale]}}</div>
                <div v-show="!service.open">
                    <div class="h-8 w-8 flex items-center justify-center">
                        <PlusIcon />

                    </div>
                </div>
                <div v-show="service.open">
                    <div class="h-8 w-8 flex items-center justify-center">
                    <CloseIconLight />

                    </div>
                </div>
            </div>
            <div class="grid !grid-rows-[0fr] transition-all" :class="{'!grid-rows-[1fr]': service.open}">
                <div class="overflow-hidden">
                    <RenderedHTML :value="service.data.body" />
                </div>
            </div>

        </div>
    </div>
</template>

<script lang="ts" setup>
import { type JSONContent } from "@tiptap/vue-3"
import RenderedHTML from "~/components/view/RenderedHTML.vue"
import CloseIconLight from "~/components/icons/CloseIconLight.vue"
import PlusIcon from "~/components/icons/PlusIcon.vue"

const { services } = defineProps({
    services: Array as PropType<{title: string, body: { [key: string]: JSONContent }}[]>
})

const mainStore = useMainStore()

const service_tracker = ref<{open: boolean, data: any}[]>([])

onMounted(() => {
    services?.forEach(service => {
        service_tracker.value.push({
            open: false,
            data: service
        })
    })
})
</script>